import styled from "styled-components";
import { colorPallet } from "../../styles/global";

export const Container = styled.div`
  padding: 5px;
  height: 23px;
  border-radius: 3px;
  background: ${colorPallet.lightBlue};
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-size: 12px;
    color: ${colorPallet.darkBlue} !important;
    text-align: center;
    font-weight: bold;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
